import { render, staticRenderFns } from "./Kuluckasozluk.vue?vue&type=template&id=5d983c5c&scoped=true"
import script from "./Kuluckasozluk.vue?vue&type=script&lang=js"
export * from "./Kuluckasozluk.vue?vue&type=script&lang=js"
import style0 from "./Kuluckasozluk.vue?vue&type=style&index=0&id=5d983c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d983c5c",
  null
  
)

export default component.exports